//记得在 src\components\lang\zhLoad.js 里面添加对象
const user= {
  clientId:'应用编码',
  clientName:'应用名称',
  userNo: '系统登录名',
  userName:'用户姓名',
  useStatusDesc: '状态',
  roleName:'角色',
  roleCode: '角色',
  officeTel:'办公电话',
  mobileTel:'手机',
  addr:'地址',
  fax:'传真',
  email:'电子邮件',
  remark:'备注',
  addUser:'新增用户',
  editUser:'修改用户',
  assignRole:'分配角色',
  editPwd:'修改密码',
  resetPwd:'重置密码',
  currentPwd:'当前密码',
  newPwd:'输入新密码',
  enterAgain:'再次输入',
  rdcNo: '发货仓编码',
  destRdcNo: '收货仓编码',
  rdcName: '仓库名称',
  city: '城市',
  address: '地址',
  lng: '经度',
  lat: '纬度',
  activeOff: '是否激活',
  carrierNo: '承运商编号',
  resetBind: '解绑微信',

  carrierShortName: '承运商简称',
  contact: '联系人',
  mobile: '联系电话',
  activeOffs: '是否有效',
  userTypeNo: '用户类型',

  carrierName: '承运商名称',
  brandCode: '品牌编号',
  brandName: '品牌名称',
  warehouseName: '仓库名称',
  warehouseCode: '仓库编码',
  counterName: '柜台名称',
  counterCode: '柜台编号',
  branCode: '品牌',
  counterNo: '柜台',
  rolerNo: '角色',

  counter: '柜台',
  searchCounter: '搜索柜台',
  waitCounter: '待选柜台',
  chooseCounter: '已选柜台',
  userCategoryNo: '类别',
  userCategoryName: '类别',
  isQiyeWxLoginStr: '是否绑定微信',
  reportDashBoard: 'dashboard',
  employeeId:'员工ID',
  msg:{
    userNo:'请输入用户名',
    userName:"请输入用户昵称",
    userCategory: '请选择账号类别',
    userType: '请选择用户类型',
    currentPwd:'请输入当前密码',
    newPwd:'请输入新密码',
    enterAgain:'请再次输入新密码',
    inputPwdError:'两次输入密码不同，请重新输入',
    setRoleAllocation:'确认保存么吗？本次操作未勾选角色，继续操作将会删除原有角色！',
    counterMsg: '请输入客户编号或名称',
    mobileTel:'请输入手机号'
  }
};
export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/lang/user.zh.js